import { GlDisclosureDropdown, GlLink, GlSprintf, GlToggle, GlToastMixin } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { __, s__ } from '~/locale';
import { createAlert } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/alert.js?vue3';
import { parseErrorMessage } from '~/lib/utils/error_message';
import { getIdFromGraphQLId } from '~/graphql_shared/utils';
import glAbilitiesMixin from '~/vue_shared/mixins/gl_abilities_mixin';
import ConfirmActionModal from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/confirm_action_modal.vue?vue3';
import FlowTriggerEventTokens from '/builds/gitlab/gitlab-ee/ee/app/assets/javascripts/ai/duo_agents_platform/components/common/flow_trigger_event_tokens.vue?vue3';
import updateAiFlowTrigger from 'ee/ai/duo_agents_platform/graphql/mutations/update_ai_flow_trigger.mutation.graphql';
import deleteAiFlowTrigger from 'ee/ai/duo_agents_platform/graphql/mutations/delete_ai_flow_trigger.mutation.graphql';
import aiCatalogFlowQuery from 'ee/ai/catalog/graphql/queries/ai_catalog_flow.query.graphql';
import { FLOW_TRIGGERS_NEW_ROUTE, FLOW_TRIGGERS_EDIT_ROUTE } from 'ee/ai/duo_agents_platform/router/constants';
import { canManageAiFlowTriggers } from '../permissions';
import { getRegistryItem } from '/builds/gitlab/gitlab-ee/ee/app/assets/javascripts/ai/catalog/item_type_registry.js?vue3';
import AiCatalogItemField from './ai_catalog_item_field.vue';
export default {
    name: 'TriggerFieldEE',
    components: {
        GlDisclosureDropdown,
        GlLink,
        GlSprintf,
        GlToggle,
        ConfirmActionModal,
        AiCatalogItemField,
        FlowTriggerEventTokens
    },
    mixins: [
        glAbilitiesMixin(),
        GlToastMixin
    ],
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    data () {
        return {
            togglingIds: [],
            triggerIdToDelete: null
        };
    },
    computed: {
        itemRegistry () {
            return getRegistryItem(this.item.itemType);
        },
        flowTriggers () {
            return this.item.configurationForProject?.flowTriggers ?? [];
        },
        itemTypeLabel () {
            return this.itemRegistry.label;
        },
        canManageTriggers () {
            return canManageAiFlowTriggers({
                glAbilities: this.glAbilities
            });
        }
    },
    methods: {
        triggerEditPath (triggerId) {
            return {
                name: FLOW_TRIGGERS_EDIT_ROUTE,
                params: {
                    id: getIdFromGraphQLId(triggerId)
                }
            };
        },
        dropdownItems (flowTrigger) {
            return [
                {
                    text: __('Edit'),
                    to: this.triggerEditPath(flowTrigger.id)
                },
                {
                    text: __('Delete'),
                    extraAttrs: {
                        class: '!gl-text-danger'
                    },
                    action: ()=>{
                        this.triggerIdToDelete = flowTrigger.id;
                    }
                }
            ];
        },
        isToggling (id) {
            return this.togglingIds.includes(id);
        },
        async toggleTrigger (id, active) {
            this.togglingIds = [
                ...this.togglingIds,
                id
            ];
            try {
                const { data } = await this.$apollo.mutate({
                    mutation: updateAiFlowTrigger,
                    variables: {
                        input: {
                            id,
                            active
                        }
                    }
                });
                const { errors } = data.aiFlowTriggerUpdate;
                if (errors.length > 0) {
                    createAlert({
                        message: errors.join(' ')
                    });
                    return;
                }
                this.$toast.show(active ? s__('DuoAgentsPlatform|Trigger turned on') : s__('DuoAgentsPlatform|Trigger turned off'));
            } catch (error) {
                createAlert({
                    message: parseErrorMessage(error, s__('DuoAgentsPlatform|Failed to update trigger.')),
                    error,
                    captureError: true
                });
            } finally{
                this.togglingIds = this.togglingIds.filter((togglingId)=>togglingId !== id);
            }
        },
        async deleteTrigger () {
            try {
                const { data } = await this.$apollo.mutate({
                    mutation: deleteAiFlowTrigger,
                    variables: {
                        id: this.triggerIdToDelete
                    },
                    refetchQueries: [
                        aiCatalogFlowQuery
                    ],
                    awaitRefetchQueries: true
                });
                const { errors } = data.aiFlowTriggerDelete;
                if (errors.length > 0) {
                    createAlert({
                        message: errors.join(' ')
                    });
                    return;
                }
                this.$toast.show(s__('DuoAgentsPlatform|Trigger deleted successfully.'));
            } catch (error) {
                createAlert({
                    message: parseErrorMessage(error, s__('DuoAgentsPlatform|Failed to delete trigger.')),
                    error,
                    captureError: true
                });
            } finally{
                this.triggerIdToDelete = null;
            }
        }
    },
    FLOW_TRIGGERS_NEW_ROUTE
};
